<template>
  <div>
    <CommonIndex :pageType="pageType" @showDetail="showDetail" />
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';
import CommonIndex from '@/views/safety-device/component/common-index';
import { createDrawer } from '@triascloud/x-components';
import sewageMeterDetail from './sewage-detail';
import { pageTypeEnum } from '@/views/safety-device/component/safety-utils';

@Component({
  components: {
    CommonIndex,
  },
})
export default class SewageMonitor extends Vue {
  // 水质监测
  pageType = pageTypeEnum.sewageMonitor;

  modalDrawer = null;
  handleCloseModalDrawer() {
    this.modalDrawer.handleClosed();
  }
  showDetail(record) {
    this.modalDrawer = createDrawer(
      () => (
        <sewageMeterDetail
          detailData={record}
          pageType={this.pageType}
          close={this.handleCloseModalDrawer}
        />
      ),
      {
        title: this.$t('safety.deviceDetail'),
        width: '720px',
        wrapClassName: 'deviceDetail',
      },
    );
  }
}
</script>

<style lang="less" module>
@import '@/views/safety-device/component/safety.less';
</style>
